import type { TFunction } from "i18next";

import type { IInformationItemVariants } from "@components/molecules/informationItem";

export const VInformationItemVariants = (
  t: TFunction<"common">,
): IInformationItemVariants => ({
  appointment: { noAvatar: true, title: t("visitInfo") },
  doctor: { title: t("doctorInfo") },
  patient: { title: t("patientInfo") },
});
